<template>
    <div>
        <div class="tool-bar" v-bind:class="{ 'visible': showToolBar }" >
            <v-btn v-on:click="removeSelection" flat icon ><v-icon>arrow_back</v-icon></v-btn>
            <span class="title">{{ $t("message.Back") }}</span>
        </div>
        <div v-bind:class="{'hidden': hideListing, 'list-container': true}">
            <div v-for="resource in collection" v-bind:key="resource.projectId" class="list-row">
                <div class="list-columns">
                    <div>
                        <custom-checkbox v-bind:ref="resource.refName" v-bind:id="resource.projectId" v-bind:letter="firstLetter(resource.name)" v-on:change="selectItem(resource, $event)" ></custom-checkbox>
                    </div>
                    <div >{{ resource.name }}</div>
                </div>
                <div class="list-item-tools"> 
                    <v-btn flat icon small :to="editLink(resource.projectId)"><v-icon size="19px" color="#616161">edit</v-icon></v-btn>
                    <v-btn flat icon small  v-on:click="deleteEntry(resource.deleteHref)"><v-icon size="19px" color="#616161">delete</v-icon></v-btn>
                </div>
            </div>
            <div  class="fab-icon">
                <v-btn fab dark color="secondary" :to="addLink()"><v-icon dark>add</v-icon></v-btn>
            </div>
        </div>
        <router-view v-on:save="load"></router-view>
    </div>
</template>

<script>
import GenericRepository from "../../services/GenericRepository.js";
import HAL from "../../helpers/HAL.js";
import { mapGetters } from "vuex";
import CustomCheckbox from "../primitive_componets/CustomCheckbox.vue";

export default {
  name: "ProjectListing",
  computed: {
    ...mapGetters(["menuItems", "authData"]),
    showToolBar: function() {
      return this.selectedItems.length > 0;
    },
    hideListing: function() {
      return this.isInEditMode;
    }
  },
  components: {
    CustomCheckbox
  },
  data() {
    return {
      collection: [],
      href: "",
      next: "",
      previous: "",
      selectedItems: [],
      isLoadingData: false,
      isInEditMode: false
    };
  },
  methods: {
    editLink(id) {
      return "/projects/" + id;
    },
    addLink() {
      return "/projects/add";
    },
    firstLetter(a) {
      if (a && a.length > 0) {
        return a.charAt(0);
      }
      return "";
    },
    load() {
      this.isLoadingData = true;
      this.collection = [];
      GenericRepository.getCollection(this.href).then(
        function(response) {
          if (response.data.status == "Success") {
            let items = HAL.getEmbededResources(response.data, "help:project");
            for (let i in items) {
              items[i].refName = "project_" + items[i].projectId;
              let deleteLink = HAL.getLink(items[i], "help:project-delete");
              items[i].deleteHref = deleteLink ? deleteLink.href : null;
              this.collection.push(items[i]);
            }
            this.next = HAL.getLink(response.data, "help:projects", "Next");
            if (items.length > 0) this.isLoadingData = false;
          }
        }.bind(this)
      );
    },
    loadNext() {
      this.isLoadingData = true;
      if (!this.next) return;
      GenericRepository.getCollection(this.next.href).then(
        function(response) {
          if (response.data.status == "Success") {
            let items = HAL.getEmbededResources(response.data, "help:project");
            for (let i in items) {
              items[i].refName = "project_" + items[i].projectId;
              let deleteLink = HAL.getLink(items[i], "help:project-delete");

              items[i].deleteHref = deleteLink ? deleteLink.href : null;
              this.collection.push(items[i]);
            }
            this.next = HAL.getLink(response.data, "help:projects", "Next");

            if (items.length > 0) this.isLoadingData = false;
          }
        }.bind(this)
      );
    },
    selectItem(item, value) {
      if (value) {
        this.selectedItems.push(item);
      } else {
        let index = this.selectedItems.indexOf(item);
        if (index != -1) {
          this.selectedItems.splice(index, 1);
        }
      }
    },
    removeSelection() {
      let items = [];
      for (let i in this.selectedItems) {
        items.push(this.selectedItems[i]);
      }

      for (let i in items) {
        let elm = this.$refs[items[i].refName];
        if (elm.length > 0) elm[0].clickCheckbox();
      }
    },
    handleScroll() {
      if (this.isLoadingData) return;
      let threshold =
        document.getElementById("inspire").scrollHeight -
        document.getElementById("app").clientHeight -
        100;
      if (threshold <= window.scrollY) {
        this.loadNext();
      }
    },
    deleteEntry(link) {
      if (link) {
        if (confirm(this.$t("message.DeleteDialogMessage")) == true) {
          GenericRepository.deleteEntity(link).then(
            function(response) {
              if (response.data.status == "Success") {
                this.load();
              }
            }.bind(this)
          );
        }
      }
    }
  },
  created() {
    if (this.$route.params.id) this.isInEditMode = true;
    else this.isInEditMode = false;
    if (this.authData.access_token != null) {
      for (let i in this.menuItems) {
        if (this.menuItems[i].name == "help:projects") {
          this.href = this.menuItems[i].collection;
          break;
        }
      }
      this.load();
      window.addEventListener("scroll", this.handleScroll);
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    "$route.params.id": function(id) {
      if (id) this.isInEditMode = true;
      else this.isInEditMode = false;
    }
  }
};
</script>

<style lang="stylus">
@import '../../stylus/main.styl'
@import '../../assets/css/listing.css'
@import '../../assets/css/tool-bar.css'
</style>



